import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FazerCotacaoComponent } from './Components/fazer-cotacao/fazer-cotacao.component';
import { MostrarProdutosComponent } from './Components/mostrar-produtos/mostrar-produtos.component';
import { ConfirmacaoComponent } from './Components/confirmacao-cotacao/confirmacao.component'

/*import { ConfirmacaoComponent } from './Components/confirmacao-cotacao/confirmacao.component';
import { PagamentoComponent } from './Components/pagamento/pagamento.component';*/

import { PagamentoComponent } from './Components/pagamento/pagamento.component'
import { Page404Component } from './shared/Page404/page404.component';
import { from } from 'rxjs';
const routes: Routes = [
    {
        path: 'Cotacao',
        component: FazerCotacaoComponent,
    },
    {
        path: 'MostrarProdutos',
        component: MostrarProdutosComponent,
    },
    {
        path: 'Pagamento',
        component: PagamentoComponent,
    },
    {
        path: 'Confirmacao',
        component: ConfirmacaoComponent,
    },
    {
        path: 'Pagamento',
        component: PagamentoComponent,
    },
    {
        path: '**', redirectTo: '/not-found'

    },
    {
        path: 'not-found',
        component: Page404Component
    },


];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})
export class AppRoutingModule { }
